import getStore from '../store';

export default function getSelectedProjectNameOrUndefined(): string | undefined {
    const { selectedProjectId, projects } = getStore();
    const selectedProject = selectedProjectId ? projects.get(selectedProjectId) : undefined;
    return selectedProject ? selectedProject.name : undefined;
}
